"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i=require("@mui/material"),e=require("../../../../../styled-24c16b06.js");require("../../../../../extends-7fef164d.js");require("../../../../../createTheme-fa1f72a4.js");require("../../../../../index-90dcd9ec.js");require("../../../../../_commonjsHelpers-6763f629.js");require("../../../../../index-59f8771f.js");require("../../../../../emotion-styled.browser.esm-211a6991.js");require("react");require("../../../../../emotion-element-43c6fea0.browser.esm-bc50eac8.js");require("../../../../../emotion-react.browser.esm-2f6e35ea.js");require("../../../../../hoist-non-react-statics.cjs-081bcdb8.js");require("react/jsx-runtime");require("../../../../../getDisplayName-a38893db.js");const t=e.styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 8px;
  margin-bottom: ${({theme:r})=>r.spacing(2.5)};
  gap: 8px;
`,l=e.styled("span")`
  display: flex;
  flex-direction: column;
`,u=e.styled(i.Button)`
  display: flex;
  align-items: center;
  padding: 4px 18px 4px 8px;
`;exports.Bubble=u;exports.BubbleDetails=l;exports.Bubbles=t;
